import * as React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { ApiResponse } from 'apisauce';
import { toast } from 'react-toastify';
import { IKeywords, IWorkflowItemStep } from '../../../../common/sharedTypes';
import Api from '../../../../services/Api';
import { openReport } from '../../Keywords/redux-objects/actions';
import { injuryStatusOptions, yesNo } from '../../../Forms/Keywords/presentation/KeywordsForm';
import ManagementKeywordsController from '../../../Forms/Keywords/controller/ManagementKeywordsController';
import * as urls from '../../../shared/urls';

interface IAddEditKeywordsModalOwnProps {
  show: boolean;
  onHide: () => void;
}

interface IAddEditKeywordsReduxProps {
  openReport: (workflowItemStep: IWorkflowItemStep) => Promise<void>;
}

type IAddEditKeywordsModalProps =
  IAddEditKeywordsModalOwnProps & IAddEditKeywordsReduxProps;

interface IAddEditKeywordsModalState {
  crashKeySearch: string;
  keywordData: IKeywords;
  canEditReportType: boolean;
}

interface IAddEditKeywordsDataResponse {
  workflowItemStep: IWorkflowItemStep;
  canEditReportType: boolean;
}

class AddEditKeywordsModal extends React.Component<IAddEditKeywordsModalProps, IAddEditKeywordsModalState> {
  constructor(props: IAddEditKeywordsModalProps) {
    super(props);
    this.state = {
      crashKeySearch: '',
      keywordData: null,
      canEditReportType: false,
    };
  }

  onHide() {
    this.setState({
      keywordData: null,
    });

    this.props.onHide();
  }

  handleKeywordSearch(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault()

    Api.get(urls.GET_ADD_EDIT_KEYWORDS_DATA, {
      crashKey: this.state.crashKeySearch
    })
      .then((response: ApiResponse<IAddEditKeywordsDataResponse>) => {
        if (response.ok) {
          const openWorkflowItemStep = response.data.workflowItemStep;
          const canEditReportType = response.data.canEditReportType;
          const { keywords } = openWorkflowItemStep.workflowItem.report;

          keywords.propertyDamageIndicator = yesNo.find(f => f.description.toLocaleLowerCase() === keywords.propertyDamageIndicator?.toLocaleLowerCase())?.description.toString();
          keywords.workZoneIndicator = yesNo.find(f => f.description.toLocaleLowerCase() === keywords.workZoneIndicator?.toLocaleLowerCase())?.description.toString();
          keywords.truckBusIndicator = yesNo.find(f => f.description.toLocaleLowerCase() === keywords.truckBusIndicator?.toLocaleLowerCase())?.description.toString();
          keywords.nonMotoristIndicator = yesNo.find(f => f.description.toLocaleLowerCase() === keywords.nonMotoristIndicator?.toLocaleLowerCase())?.description.toString();
          keywords.injuryStatus = injuryStatusOptions.find(f => f.name.toLocaleLowerCase() === keywords.injuryStatus?.toLocaleLowerCase())?.name.toString();

          this.setState({
            keywordData: keywords,
            canEditReportType: canEditReportType
          });
          this.props.openReport(openWorkflowItemStep);
        }
        else {
          toast.error(response.data);
        }
      })
  }

  render() {
    const { keywordData, canEditReportType } = this.state;

    return (
      <Modal
        show={this.props.show}
        onHide={() => this.onHide()}
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add/Edit Keywords</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={(e) => this.handleKeywordSearch(e)}>
            <Row style={{ alignItems: 'flex-end' }} className="pb-3">
              <Col xs="10">
                <Form.Group controlId="crashKey">
                  <Form.Label>Crash Key</Form.Label>
                  <Form.Control
                    type="text"
                    value={this.state.crashKeySearch}
                    name="crashKey"
                    onChange={(e) => this.setState({ crashKeySearch: e.target.value })}
                    disabled={keywordData !== null}
                  />
                </Form.Group>
              </Col>
              <Col
                xs="2"
                className="pl-0"
              >
                {keywordData === null ? (
                  <Button
                    variant="primary"
                    style={{ width: '100%' }}
                    type="submit"
                  >
                    Search
                  </Button>
                ) : (
                  <Button
                    variant="secondary"
                    onClick={(e) => { e.preventDefault(); this.setState({ keywordData: null }) }}
                    style={{ width: '100%' }}
                    type="button"
                  >
                    New Search
                  </Button>
                )}
              </Col>
            </Row>
          </form>
          {keywordData !== null &&
            <div>
              <ManagementKeywordsController
                keywords={keywordData}
                canEditReportType={canEditReportType}
              />
            </div>
          }
        </Modal.Body>
      </Modal>
    )
  }
}

const mapStateToProps = (reduxState: any) => {
  return {};
};

const mapDispatchToProps = {
  openReport,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddEditKeywordsModal)
);